import { useEffect } from 'react'

export function BodyBlocker() {
  useEffect(() => {
    const prevent = (e: Event) => {
            const el = e.target as HTMLElement
      // Разрешаем взаимодействие с селекторами и интерактивными элементами
      if (
        el?.tagName === 'SELECT' || el?.closest('select') ||
        el?.tagName === 'INPUT' || el?.closest('input') ||
        el?.tagName === 'TEXTAREA' || el?.closest('textarea') ||
        el?.tagName === 'BUTTON' || el?.closest('button') ||
        el?.closest('[data-interactive]') ||
        // Разрешаем прокрутку в настройках
        el?.closest('.settings-window')
      ) return

      e.preventDefault()
      e.stopPropagation()
    }

    document.addEventListener('touchmove', prevent, { passive: false })
    document.addEventListener('wheel', prevent, { passive: false })
    document.addEventListener('touchend', prevent, { passive: false }) 
    document.addEventListener('pointerdown', prevent, { passive: false })

    return () => {
      document.removeEventListener('touchmove', prevent)
      document.removeEventListener('wheel', prevent)
      document.removeEventListener('touchend', prevent)
      document.removeEventListener('pointerdown', prevent)
    }
  }, [])

  return null
}
